'use client';
import { Code, Sparkles } from 'lucide-react';
import { useT } from '../../i18n';

const ComponentsSection = () => {
  const t = useT();

  const components = [
    {
      name: t('components.scroll.name'),
      tech: t('components.scroll.tech'),
      price: 'HK$300–500',
      description: t('components.scroll.desc'),
    },
    {
      name: t('components.i18n.name'),
      tech: t('components.i18n.tech'),
      price: 'HK$500–800',
      description: t('components.i18n.desc'),
    },
    {
      name: t('components.cf-track.name'),
      tech: t('components.cf-track.tech'),
      price: 'HK$600–800',
      description: t('components.cf-track.desc'),
    },
    {
      name: t('components.cf-webhook.name'),
      tech: t('components.cf-webhook.tech'),
      price: 'HK$400–600',
      description: t('components.cf-webhook.desc'),
    },
    {
      name: t('components.og.name'),
      tech: t('components.og.tech'),
      price: 'HK$300–500',
      description: t('components.og.desc'),
    },
  ];

  return (
    <section id="components" className="py-12 lg:py-16 bg-jkd-gray-100/50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8">
          <span className="inline-block px-4 py-2 bg-jkd-black text-jkd-gold text-sm font-mono tracking-widest mb-4 rounded">
            {t('components.tag')}
          </span>
          <h2 className="section-title text-white">
            <span className="text-gradient-gold">{t('components.title')}</span>
          </h2>
          <p className="section-subtitle mx-auto mt-4">
            {t('components.subtitle')}
          </p>
          <p className="text-jkd-gold text-lg mt-4 italic">{t('components.quote')}</p>
          <div className="divider-gold mx-auto mt-6" />
        </div>

        {/* Components Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {components.map((component, index) => (
            <div
              key={index}
              className="group card-dark hover:border-jkd-gold/50 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-3">
                <Code className="w-5 h-5 text-jkd-gold" />
                <span className="price-tag">{component.price}</span>
              </div>
              <h3 className="text-base font-bold text-white mb-2">{component.name}</h3>
              <p className="text-jkd-gold/70 text-xs font-mono mb-2">{component.tech}</p>
              <p className="text-gray-300 text-sm leading-relaxed">{component.description}</p>
            </div>
          ))}
        </div>

        {/* Full Access Card */}
        <div className="mt-8">
          <div className="relative card-dark border-jkd-gold/30 hover:border-jkd-gold transition-all duration-300">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-4">
                  <Sparkles className="w-7 h-7 text-jkd-gold" />
                  <h3 className="text-xl font-bold text-white">{t('components.full.title')}</h3>
                </div>
                <p className="text-gray-300 leading-relaxed mb-4">
                  {t('components.full.desc')}
                </p>
                <div className="flex flex-wrap gap-3 mb-4">
                  <span className="tag">{t('components.full.tag1')}</span>
                  <span className="tag">{t('components.full.tag2')}</span>
                  <span className="tag">{t('components.full.tag3')}</span>
                </div>
                {/* Components Image */}
                <div className="rounded-lg overflow-hidden border border-jkd-gray-200">
                  <img
                    src="/images/moax4xwog6.png"
                    alt="Components Library"
                    className="w-full h-auto"
                  />
                </div>
              </div>
              <div className="text-center lg:text-right">
                <div className="flex items-baseline justify-center lg:justify-end gap-2 mb-4">
                  <span className="text-3xl font-black text-jkd-gold">HK$2,000</span>
                  <span className="text-gray-400">{t('components.perYear')}</span>
                </div>
                <p className="text-gray-500 text-sm">{t('components.orMonthly')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComponentsSection;
